import React from "react";

import Dropdown from "../../Layout/Inputs/Dropdown/";

const TextSize = ({ allowedFontSizes, fontSize, onUpdateSize }) => {
  const options = allowedFontSizes.split(","),
    // The options in the array are strings apparently, so the value needs to match
    value = fontSize.toString();

  const trimOptions = options.map((option) => {
    // Get rid of the space in each of the font options
    return option.trim();
  });

  const handleOnUpdateSize = (value) => {
    onUpdateSize(value);
  };

  return (
    <div className="tool__textsize">
      <Dropdown
        title="Size"
        value={value}
        options={trimOptions}
        handleSelectOption={handleOnUpdateSize}
        incrementor={true}
      />
    </div>
  );
};

export default TextSize;
